import { DetailedHTMLProps, FC, TrackHTMLAttributes, useRef, useState, VideoHTMLAttributes } from 'react';

import { HeroBanner } from '@purpur/library';

export type HeroBannerVideoProps = {
    videoProps: DetailedHTMLProps<VideoHTMLAttributes<HTMLVideoElement>, HTMLVideoElement>;
    captionProps?: DetailedHTMLProps<TrackHTMLAttributes<HTMLTrackElement>, HTMLTrackElement>;
    playAriaLabel: string;
    pauseAriaLabel: string;
};

export const HeroBannerVideo: FC<HeroBannerVideoProps> = ({
    videoProps,
    captionProps,
    playAriaLabel,
    pauseAriaLabel,
}) => {
    const [isPlaying, setIsPlaying] = useState(true);
    const videoRef = useRef<HTMLVideoElement>(null);

    const togglePlayPause = () => {
        if (videoRef.current) {
            if (isPlaying) {
                videoRef.current.pause();
            } else {
                videoRef.current.play();
            }
            setIsPlaying(!isPlaying);
        }
    };

    return (
        <HeroBanner.Media
            videoPauseAriaLabel={pauseAriaLabel}
            videoPlayAriaLabel={playAriaLabel}
            isPlaying={isPlaying}
            togglePausePlay={() => {
                togglePlayPause();
            }}
        >
            <video
                ref={videoRef}
                autoPlay={true}
                loop={true}
                muted={true}
                data-element="Video"
                data-element-name={videoProps['aria-label']}
                {...videoProps}
            />
            {captionProps && <track kind="caption" {...captionProps} />}
        </HeroBanner.Media>
    );
};
